import loginedApi from "../apis";
import { toast } from "react-toastify";

import { SIGNUP_SUCCESS_ACTION } from "./type";
import CryptoJS from "crypto-js";
  var hashcode = CryptoJS.SHA256(process.env.REACT_APP_PREFIX+process.env.REACT_APP_TOKEN+process.env.REACT_APP_SECRETKEY);

const publicIp = require("public-ip");
let IP = publicIp.v4();
let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;
let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B")
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D")
}//replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`

let countrycoderes;
let doctorscountrycode;



export const signup_action =
  ({ values, userType, OTP, history, redirect }) =>
    async (dispatch) => {
      // var hash = CryptoJS.SHA512(values.password);

      console.log("Signup Params......", { values, userType, OTP });

      countrycoderes = await loginedApi.post("getcountrycode",
        {
        token :hashcode.toString(),
          "version": "2.0",
          "data": { browserTimeZone: `GMT${formatTime}`, },
          "requestType": 1058
        });

      doctorscountrycode = countrycoderes.data.data;
      var hash = CryptoJS.SHA512("C2MD|"+values.password);

      let password = hash.toString();

      let hashPassword = hash.toString(CryptoJS.enc.Base64);
      // let hashPassword = CryptoJS.SHA512("C2MD|"+password);
      let limit = values.dial_code?.length;
      let mobNo = values.mobileNumber;
      let mobileNo = `%2B${values.dial_code}${" "}${mobNo}`;
      const clientDetailsLocal = JSON.parse(localStorage.getItem("ClinicDetails"));
      const res = await loginedApi.post("signup", {
        requestType: 2,
        data: {

          lastName: "",
          accessCountry: doctorscountrycode.Country,
          source: "Web APP",
          useragent: userAgent,
          department: "",
          password: password,
          hashPassword: hashPassword,
          userType: userType,
          mobileNumber: mobileNo,
          emailId: values.email,
          referenceOTP: OTP,
          deviceId: "",
          signupFrom: "c2md",
          Os: platform,
          firstName: values.fullName,
          clinicId: clientDetailsLocal.id,
          Ipaddress: IP,
          type: "",
          browserTimeZone: `GMT${formatTime}`,
          speciality: "",
          appname: "C2MD Patient",
        },
      token :hashcode.toString(),
      });

      if (res.data.data) {
        let response = res.data.data;

        if (response.hasOwnProperty("info")) {
          return response;
        } else {
          dispatch({
            type: SIGNUP_SUCCESS_ACTION,
            payload: res.data.data,
          });
          //await localStorage.setItem("userData", response);
          await localStorage.setItem("userData", JSON.stringify(response));
          if (res.data?.data?.userType == "Patient") {

            if (redirect) {
              history.push(redirect);
            } else {
              history.push("/dashboard");
            }
          }
        }
        return response;
      }
    };
export const generate_OTP = (formData) => async (dispatch) => {

console.log("generate_OTP",formData)
  let limit = formData.dial_code?.length;
  let mobNo = formData.mobileNumber!=undefined?formData.mobileNumber:formData.mobile;
  let mobileNo = `%2B${formData.dial_code}${" "}${mobNo}`;
  const clientDetailsLocal = JSON.parse(localStorage.getItem("ClinicDetails"));
  const res = await loginedApi.post("getmobileotp", {
    token :hashcode.toString(),
    requestType: "25",
    data: {
      mobileNumber: mobileNo,
      Os: platform,
      Ipaddress: IP,
      clinicId:clientDetailsLocal.id,
      useragent: userAgent,
    },
  });

  return res.data && res.data.data.info;
};



export const signup_with_Google =
  ({ userType, Data, mobilenumber, history }) =>
    async (dispatch) => {
      const clientDetailsLocal = JSON.parse(localStorage.getItem("ClinicDetails"));
      console.log("Data", Data);
      const res = await loginedApi.post("signup", {
        requestType: 2,
        data: {
          lastName: "",
          accessCountry: "",
          source: "c2mdapp",
          useragent: userAgent,
          department: "",
          password: "",
          hashPassword: "",
          userType: Data.userType,
          mobileNumber: mobilenumber,
          emailId: Data.value.email,
          referenceOTP: "",
          deviceId: "",
          signupFrom: "c2md",
          Os: platform,
          firstName: Data.value.name,
          socialProfileId: Data.value.googleId,
          clinicId:clientDetailsLocal.id,
          Ipaddress: IP,
          type: "signUpGoogle",
          browserTimeZone: `GMT${formatTime}`,
          speciality: "",
          appname: "C2MD Patient",
        },
      token :hashcode.toString(),
      });




      if (res.data.data) {
        let response = res.data.data;



        if (response.hasOwnProperty("info")) {
          // toast.error(response.info, {
          //   position: toast.POSITION.TOP_CENTER,
          // });

          return response;
        } else {

          dispatch({
            type: SIGNUP_SUCCESS_ACTION,
            payload: JSON.stringify(res.data.data),
          });
          //await localStorage.setItem("userData", response);
          await localStorage.setItem("userData", JSON.stringify(response));
          if (res.data?.data?.userType == "Patient") {

            if (history?.location?.state?.redirection) {
              history.push(history?.location?.state?.redirection);
            } else {
              history.push("/dashboard");
            }
          }
          else {
            history.push("/dashboard");
          }
          //history.push("/DoctorListing");
        }
        return response;
      }
      else {
        console.log("Else data.data.............");
      }
    };

export const checkUser =
  ({ searchtype, searchKey }) =>
    async (dispatch) => {
      const res = await loginedApi.post("useravailability", {
        requestType: 22,
        token :hashcode.toString(),
        data: { searchtype: searchtype, searchKey: searchKey },
      });

      return res.data?.data;
    };

export const CheckEmailavailbility =
  ({ searchtype, searchKey, userType }) =>
    async (dispatch) => {
      const res = await loginedApi.post("getemailotp", {
        requestType: 10,
        token :hashcode.toString(),
        data: { userName: "User", emailId: searchKey, userType: userType },
      });

      return res.data?.data;
    };
export const CheckMobileavailbility =
  ({ searchKey }) =>
    async (dispatch) => {
      const res = await loginedApi.post("getmobileavailability", {
        requestType: 8,
        token :hashcode.toString(),
        data: { userName: "User", searchKey: searchKey, "Appname": "C2MD Web" },
      });

      return res.data?.data;
    };

export const CheckuserEmailavailbility =
  ({ searchtype, searchKey, userType }) =>
    async (dispatch) => {
      const res = await loginedApi.post("getemaiavailability", {
        requestType: 10,
        token :hashcode.toString(),
        data: { userName: "User", emailId: searchKey, userType: userType },
      });

      return res.data?.data;
    };

export const getemailOtp =
  ({ searchtype, searchKey, userType }) =>
    async (dispatch) => {

      const res = await loginedApi.post("getOTP", {
        requestType: 37,
        token :hashcode.toString(),
        data: { userName: "User", emailId: searchKey, userType: userType },
      });

      return res.data?.data;
    };

export const getmobile =
  ({ searchtype, searchKey, userType }) =>
    async (dispatch) => {
      const clientDetailsLocal = JSON.parse(localStorage.getItem("ClinicDetails"));
      const res = await loginedApi.post("getOTP", {
        requestType: 38,
        token :hashcode.toString(),
        data: { userName: "User", mobileNumber: searchKey, userType: userType,clinicId:clientDetailsLocal.id },
      });

      return res.data?.data;
    };


